import type { RouteRecordRaw, Router } from 'vue-router'
import { MODULE_PERMISSIONS } from '@/modules/Core/constants/adminAccess'

const ReminderRoutes: RouteRecordRaw = {
  path: '/reminder',
  name: 'ReminderModulePages',
  redirect: { name: 'ManageReminderRoute' },
  children: [
    {
      path: '',
      name: 'ManageReminderRoute',
      component: () => import('./views/ManageReminderView.vue'),
      meta: {
        title: 'یادآوری',
        pageHasBack: true,
        contentFlushOnMobile: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
    requiredPermissions: [...MODULE_PERMISSIONS.reminder],
  },
}

export default (router: Router) => {
  router.addRoute(ReminderRoutes)
}
